:host{

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  object-position: center;
  background-color: var(--c7-img-background, #f6f6f6);

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: inherit;
    object-position: inherit;
    opacity: 1;
    transition: opacity .3s ease-in-out;
  }

  img:not([src]){
    display: none;
  }

}

:host(.c7-img-fit-cover){
  object-fit: var(--c7-img-fit, cover);
}

:host(.c7-img-fit-contain){
  object-fit: var(--c7-img-fit, contain);
}

:host(.c7-img-fit-scale-down){
  object-fit: var(--c7-img-fit, scale-down);;
}

:host(.c7-img-loading) {
  img {
    opacity: 0;
  }
}


